import { useTranslation } from 'react-i18next';

import React from 'react';

interface EmptyTipsProps {
  /** 提示文案 - 默认是 "暂无数据" , 传入自定义文案会覆盖默认值 */
  tips?: string;
  /** 自定义样式 - 容器的样式 */
  styles?: React.CSSProperties;
  /** 自定义按钮 - 可以传入一个按钮元素 */
  button?: React.ReactNode;
}

export function EmptyTips({ tips, styles, button }: EmptyTipsProps) {
  const { t } = useTranslation();
  const presetStyle = {
    display: 'flex',
    justifyContent: 'center',
    padding: '12px 0',
  };

  return (
    <div style={{ ...presetStyle, ...styles }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="/images/empty.svg" alt="empty" style={{ width: '129px', height: '80px' }} />
        <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{tips || t('common:empty')}</span>
        <div>{button}</div>
      </div>
    </div>
  );
}
